import { Component, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';



@Component({
  selector: 'app-ana-unita-locali',
  templateUrl: './stampa-registri-carico-scarico.component.html',
  styleUrls: ['./stampa-registri-carico-scarico.component.css']
})
export class StampaRegistriCaricoScaricoComponent extends NicaMaster {
  @ViewChild('nicaAnagrafica', { static: true }) nicaAnagrafica: NicaAnagraficaComponent
  constructor(
    public componentService: ComponentService,
    public templateService: FormsTemplateService,
    public overlaySide: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public resolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagaficaService: AnagraficaService,
  ) {
    super(
      componentService,
      templateService,
      overlaySide,
      _overlaySidePanelService,
      formTemplateService,
      resolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagaficaService,
    );
  }

  onAllEventGrid(event) {
    if (event.name === "onRowDblClick") {
      const guid = Math.random().toString().replace("0.", "");
      const instanceData = {
        reletedData: event.data,
        selectedRegistro: event.data.id,
        guid
      }
      this.componentService.setNewPopUp(guid, 'PopupStampaRegistriComponent', null, '800', null, instanceData, false, true, 'Registro Cronologico C/S', 'top')
    }
    if (event.name === "onCellPrepared") {
      if (event.dataField === 'dataProtocolloUltimoStampato' && event.data) {
        const numeroUltimoProtocollo = event.data.numeroUltimoProtocollo || ''
        const dataUltimoProtocolloStampato = event.data.dataUltimoProtocolloStampato && event.data.dataUltimoProtocolloStampato !== null ? new Date(event.data.dataUltimoProtocolloStampato).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''
        let dataProtocolloUltimoStampato = [];
        dataProtocolloUltimoStampato.push({
          value: `${dataUltimoProtocolloStampato}`
        })
        dataProtocolloUltimoStampato.push({
          value: `${numeroUltimoProtocollo}`
        })
        event.cellElement.innerHTML = `<div class="d-flex flex-row justify-content-around w-100">
            ${dataProtocolloUltimoStampato.map((item) => `<span>${item.value}</span>`).join('')}
            </div>
            `
      }
      if (event.dataField === 'dataNumeroProtocolloUltimoRentri' && event.data) {
        const NumeroUltimoProtocolloRentri = event.data.numeroUltimoProtocolloRentri || ''
        const DataUltimoProtocolloRentri = event.data.dataUltimoProtocolloRentri && event.data.dataUltimoProtocolloRentri !== null ? new Date(event.data.dataUltimoProtocolloRentri).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''
        let dataProtocolloUltimoRentri = [];
        dataProtocolloUltimoRentri.push({
          value: `${DataUltimoProtocolloRentri}`
        })
        dataProtocolloUltimoRentri.push({
          value: ` ${NumeroUltimoProtocolloRentri}`
        })
        event.cellElement.innerHTML = `<div class="d-flex flex-row justify-content-around w-100">
            ${dataProtocolloUltimoRentri.map((item) => `<span>${item.value}</span>`).join('')}
            </div>
            `
      }
    }
  }
  optionalButtonGrid(event) {
    console.log('optionalButtonGrid', event)
    if (event && event.name === "invioRentri") {
      const guid = Math.random().toString().replace("0.", "");
      const instanceData = {
        reletedData: event.row.data,
      }
      this.componentService.setNewPopUp(guid, 'PopupEsportazioneRentriComponent', null, '900', null, instanceData, false, true, 'Esportazione Rentri/DH', 'top')
      console.log('onAllEventGrid', event)
    }
  }
  optionalBottoneToolbarGrid(event) {
    // console.log('optionalBottoneToolbarGrid', event)
  }
}